import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const FontStrikethroughIcon = React.memo(function FontStrikethroughIcon(
    props: TFontStrikethroughIconProps,
): React.ReactElement {
    return (
        <IconBase aria-label="Strikethrough" viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.915 4.597C8.99 3.907 10.431 3.65 12 3.65c1.816 0 3.26.665 4.253 1.517.495.424.884.9 1.154 1.372.262.46.443.972.443 1.461h-1.7c0-.094-.044-.311-.22-.617a3.61 3.61 0 0 0-.784-.925C14.44 5.852 13.383 5.35 12 5.35c-1.431 0-2.49.243-3.165.678-.616.395-.985.991-.985 1.972 0 .723.365 1.239 1.154 1.72.8.486 1.881.837 3.108 1.235l.138.045h7.25a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 4 12v-.5a.5.5 0 0 1 .5-.5h3.355c-.96-.656-1.705-1.6-1.705-3 0-1.52.63-2.673 1.765-3.403Zm6.676 9.153h2.564c.43.605.695 1.344.695 2.25 0 1.024-.258 1.876-.708 2.566-.447.685-1.052 1.164-1.682 1.498-1.237.655-2.646.786-3.46.786-.814 0-2.204-.132-3.425-.706-1.26-.593-2.425-1.717-2.425-3.644h1.7c0 1.073.584 1.699 1.45 2.106.904.425 2.014.544 2.7.544.686 0 1.777-.119 2.665-.589.433-.229.796-.53 1.053-.924.253-.388.432-.91.432-1.637 0-.894-.416-1.5-1.188-2.022a5.403 5.403 0 0 0-.37-.228Z"
            />
        </IconBase>
    );
});

export default FontStrikethroughIcon;

// #region Types

export type TFontStrikethroughIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function'
        ? () => <FontStrikethroughIcon />
        : { ...IconBaseExample, render: FontStrikethroughIcon };

// #endregion
